import CheckboxInputT from '@components/tailwind-components/Input/CheckboxInputT';
import SelectInputWithLabelT from '@components/tailwind-components/Input/SelectInputWithLabelT';
import LabelT from '@components/tailwind-components/Label/LabelT';
import { FB_SUPPORTED_LOCALES } from '@conversed/shared/src/central/constants/locales';
import type React from 'react';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { TFacebookSettings } from '../../../../../interfaces/TFacebook';
import FacebookCallToActionList from './FacebookCallToActionList';

type Props = {
  name: string;
  control: Control<TFacebookSettings>;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const FacebookPersistentMenuItem: React.FC<Props> = ({
  name,
  control,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col' {...rest}>
      <LabelT
        text={t('settings.facebook.persistent-menu.menu-title')}
        className='!text-lg !my-3 !font-medium'
      />

      <SelectInputWithLabelT
        field={`${name}locale` as any}
        label={t('settings.facebook.persistent-menu.locale')}
        control={control}
        values={FB_SUPPORTED_LOCALES.map((locale) => ({
          value: locale,
          description: locale,
        }))}
      />

      <CheckboxInputT
        label={t('settings.facebook.persistent-menu.input-disabled')}
        control={control}
        field={`${name}inputDisabled` as any}
        id={`${name}inputDisabled`}
      />

      <LabelT
        text={t('settings.facebook.persistent-menu.actions')}
        className='!text-lg text-primary-base !my-4 !font-medium'
      />
      <FacebookCallToActionList name={`${name}actions`} control={control} />
    </div>
  );
};

export default FacebookPersistentMenuItem;
